import React from "react";

import DialogTitle from "@material-ui/core/DialogTitle";

import { EModalConfirmationTypes } from "interfaces/VetExamState";
import { checkTypeModal } from "../../helper";

import useStyles from "./styles";

interface IProps {
  type: EModalConfirmationTypes;
}

const VetExamModalTitle = (props: IProps) => {
  const { type } = props;

  const classes = useStyles();

  const { isPauseOrCloseModal, isResetModal, isExamEditInProgressModal } =
    checkTypeModal(type);

  let titleText: string = "";

  if (isResetModal) {
    titleText = "Reset Exam Form";
  } else if (isPauseOrCloseModal) {
    titleText = "Exam In Progress";
  } else if (isExamEditInProgressModal) {
    titleText = "Exam Edit In Progress";
  }

  return <DialogTitle className={classes.dialogTitle}>{titleText}</DialogTitle>;
};

export default VetExamModalTitle;
